/* eslint-disable max-len */
export default {
    name       : 'OperationAddProgress',
    props : ['newOperationState'],
    /**
     * @override
     */
    data() {
        return {
            progress: [
                {
                    text: 'Cuenta'
                },
                {
                    text: 'Tipo de producto'
                },
                {
                    text: 'Tipo de operación'
                },
                {
                    text: 'Producto'
                },
                {
                    text: 'Operación'
                }
            ]
        };
    },
    methods: {
        /**
         * Click on steper element changing actual step
         * @param {String} index of steper
         */
        stepperClick(index) {
            if (!this.newOperationState.isEdition) {
                switch (index) {
                    case 0:
                        this.newOperationState.account = {};
                        this.newOperationState.productType = {
                            type: null,
                            text: null
                        };
                        this.newOperationState.productSelected = null;
                        this.newOperationState.operationTypeSelected = null;
                        this.newOperationState.amountSharesIndicator = null;
                        this.newOperationState.maxSharesToRefund = null;
                        this.newOperationState.maxPositionsToRefund = null;
                        this.newOperationState.bankAccount = null;
                        this.newOperationState.source = null;
                        this.newOperationState.ordering = {};
                        this.newOperationState.hasNewContributor = false;
                        this.newOperationState.newContributors = [];
                        this.cleanOperationObject();

                        break;
                    case 1:
                        this.newOperationState.productType = {
                            type: null,
                            text: null
                        };
                        this.newOperationState.productSelected = null;
                        this.newOperationState.operationTypeSelected = null;
                        this.newOperationState.amountSharesIndicator = null;
                        this.newOperationState.maxSharesToRefund = null;
                        this.newOperationState.maxPositionsToRefund = null;
                        this.newOperationState.bankAccount = null;
                        this.newOperationState.source = null;
                        this.newOperationState.ordering = {};
                        this.newOperationState.hasNewContributor = false;
                        this.newOperationState.newContributors = [];
                        this.cleanOperationObject();
                        break;
                    case 2:
                        this.newOperationState.operationTypeSelected = null;
                        this.newOperationState.productSelected = null;
                        this.newOperationState.amountSharesIndicator = null;
                        this.newOperationState.maxSharesToRefund = null;
                        this.newOperationState.maxPositionsToRefund = null;
                        this.newOperationState.bankAccount = null;
                        this.newOperationState.source = null;
                        this.newOperationState.hasNewContributor = false;
                        this.newOperationState.newContributors = [];
                        this.cleanOperationObject();
                        break;
                    case 3:
                        this.newOperationState.productSelected = null;
                        this.newOperationState.amountSharesIndicator = null;
                        this.newOperationState.maxSharesToRefund = null;
                        this.newOperationState.maxPositionsToRefund = null;
                        this.newOperationState.bankAccount = null;
                        this.newOperationState.source = null;
                        this.newOperationState.hasNewContributor = false;
                        this.newOperationState.newContributors = [];
                        this.cleanOperationObject();
                        break;
                    default:
                        break;
                }
                this.newOperationState.operationStep = index < this.newOperationState.operationStep ? index : this.newOperationState.operationStep;
            } else {
                this.newOperationState.operationStep = index;
            }
        },
        /**
         * Clean OperationOjb on change spets
         */
        cleanOperationObject() {
            this.newOperationState.operationObj = {
                shares: null,
                netAmount: null,
                grossAmount: null,
                commission: null,
                withholding: null,
                per_period: null,
                per_start_date: null,
                per_end_date: null,
                is_per_end_date_undefined: null,
                per_increase_type: {
                    key: 'no-increase', name: 'Sin incremento'
                },
                per_increase: null,
                per_increase_period: null,
                product_target: null,
                xt_isin_code: null,
                xt_gestor: null,
                xt_account_origin: null,
                xt_fund_name: null,
                xt_provider: null,
                xt_fund_official_reg_number: null,
                xt_fund_nif: null,
                xt_gestor_official_reg_number: null,
                xt_gestor_nif: null,
                xt_provider_official_reg_number: null,
                xt_provider_nif: null,
                transfer_nav_on_month_end: null,
                pp_redemption_cause: null,
                pp_redemption_rendering_variation_type: null,
                pp_redemption_rendering_variation: null,
                pp_redemption_rendering_variation_date: null,
                pp_redemption_collection_method: null,
                pp_redemption_defer: null,
                pp_source_situation: null,
                pp_compartment: null,
                pp_redemption_entitlement_date: null,
                pp_plan_type: null,
                pp_xt_dgs_code: null,
                pp_xt_egs_code: null,
                pp_rights_type: null,
                pp_xt_collection_method: null,
                pp_redemption_mixed_amount: null,
                pay_method: null,
                cnmvObject: null,
                selectedMarketer: null,
                contribution_account_code: null
            };
        }
    }
};
